<template>
  <el-main>
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item>收款管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="" style="margin-left: -100px;">
          <el-col :span="5">
            <el-select v-model="form.atype" placeholder="请选择类别" style="margin-right: 0; width: 100%;">
              <el-option label="发票号码" value="invoice_no"></el-option>
              <el-option label="发票代码" value="invoice_code"></el-option>
              <el-option label="合同编号" value="contract_no"></el-option>
              <el-option label="客户公司名称" value="client_company"></el-option>
              <el-option label="品牌" value="brand"></el-option>
              <el-option label="项目名称" value="contract_name"></el-option>
              <el-option label="计划收款金额" value="amount"></el-option>
            </el-select>
          </el-col>
          <el-col :span="12" style="margin-right: 10px;">
            <el-input placeholder="请输入内容" v-model="form.key" @keyup.enter.native="search" clearable @clear="search">
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-col>
        </el-form-item>

        <el-form-item label="期望开票时间" prop="hope_time">
          <el-col :span="12">
            <el-date-picker v-model="form.hope_time" type="datetimerange" range-separator="--" start-placeholder="开始日期"
              end-placeholder="结束日期" style="margin-right: 10px;" @change="search(false)">
            </el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item label="更多" prop="type">
          <el-col :span="5" style="margin-right: 20px;">
            <el-select v-model="form.status" placeholder="开票状态" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option label="未开票" value="1"></el-option>
              <el-option label="部分开票" value="2"></el-option>
              <el-option label="已开票" value="3"></el-option>
            </el-select>
          </el-col>

          <el-col :span="5" style="margin-right: 20px;">
            <el-select v-model="form.is_receive" placeholder="收款状态" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option label="未收款" value="1"></el-option>
              <el-option label="部分收款" value="2"></el-option>
              <el-option label="已收款" value="3"></el-option>
            </el-select>
          </el-col>

          <el-col :span="5" style="margin-right: 20px;">
            <el-select v-model="form.is_apply" placeholder="是否申请发票" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option label="已申请" value="1"></el-option>
              <el-option label="未申请" value="2"></el-option>
            </el-select>
          </el-col>

          <el-col :span="5">
            <el-select v-model="form.year" placeholder="项目认列年份" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option :label="v" :value="v" v-for="(v, i) in yearList" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="已选条件">
          <el-tag v-for="tag in tags" :key="tag.key" effect="dark" closable @close="removeTag(tag)">
            {{ tag.key }}: {{ tag.value }}
          </el-tag>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <div class="filterwrap">
        <div class="filter">
          <el-checkbox-group class="filtergroup" v-model="checkList" prop="checkList" :min="5">
            <el-checkbox label="合同编号"></el-checkbox>
            <el-checkbox label="客户公司名称"></el-checkbox>
            <el-checkbox label="品牌"></el-checkbox>
            <el-checkbox label="项目名称"></el-checkbox>
            <el-checkbox label="收款计划"></el-checkbox>
            <el-checkbox label="计划收款金额"></el-checkbox>
            <el-checkbox label="计划收款时间"></el-checkbox>
            <el-checkbox label="开票状态"></el-checkbox>
            <el-checkbox label="已开票金额"></el-checkbox>
            <el-checkbox label="未开票金额"></el-checkbox>
            <el-checkbox label="期望开票时间"></el-checkbox>
            <el-checkbox label="开票时间"></el-checkbox>
            <el-checkbox label="发票类型"></el-checkbox>
            <el-checkbox label="已收款"></el-checkbox>
            <el-checkbox label="未收款"></el-checkbox>
            <el-checkbox label="收款状态"></el-checkbox>
          </el-checkbox-group>
        </div>           
        <div class="btnarea">
          <el-button @click="exportInvoiceApplyToExcel" v-if="NodeInclude('97')">导出数据</el-button>
        </div>
      </div>

      <el-table :data="itemList" border stripe style="width: 100%;" highlight-current-row>
        <el-table-column prop="contract_no" label="合同编号" header-align="center" align="center" min-width="150" v-if="check('合同编号')">
          <template slot-scope="scope">
            <div class="linkwrap normal">
              <el-link type='primary' class="link" @click="link(`/project/detail?id=${scope.row.project_id}`)">{{  scope.row.projectArr ? (scope.row.projectArr.contract_no ? scope.row.projectArr.contract_no : '暂无') : ''}}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="client_company" label="客户公司名称" header-align="center" align="center" min-width="200" v-if="check('客户公司名称')">
          <template slot-scope="scope">
            {{ scope.row.projectArr ? scope.row.projectArr.client_company : ''}}
          </template>           
        </el-table-column>
        <el-table-column prop="brand" label="品牌" header-align="center" align="center" min-width="150" v-if="check('品牌')">
          <template slot-scope="scope">
            {{ scope.row.projectArr ? scope.row.projectArr.brand : ''}}
          </template> 
        </el-table-column>
        <el-table-column prop="contract_name" label="项目名称" header-align="center" align="center" min-width="300" v-if="check('项目名称')" >
          <template slot-scope="scope">
            {{ scope.row.projectArr ? scope.row.projectArr.contract_name : ''}}
          </template> 
        </el-table-column>
        <el-table-column prop="bill_name" label="收款计划" header-align="center" align="center" min-width="300" v-if="check('收款计划')">
          <template slot-scope="scope">
            {{  scope.row.bill_name }}
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="计划收款金额" header-align="center" align="right" min-width="100" v-if="check('计划收款金额')">
          <template slot-scope="scope">
            {{ scope.row.amount }}
          </template>
        </el-table-column>
        <el-table-column prop="estimate_date" label="计划收款时间" header-align="center" align="center" min-width="120" v-if="check('计划收款时间')">
          <template slot-scope="scope">
            {{ scope.row.estimate_date != '0000-00-00' ? scope.row.estimate_date : (scope.row.bill_date != '0000-00-00' ? scope.row.bill_date : '暂无')}}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="开票状态" header-align="center" align="center" min-width="80" v-if="check('开票状态')">
          <template slot-scope="scope">
            {{ scope.row.applyArr ? dd.invoice_status[scope.row.applyArr.status] : '未开票' }}
          </template> 
        </el-table-column>
        <el-table-column prop="finishedInvoice" label="已开票金额" header-align="center" align="right" min-width="100" v-if="check('已开票金额')"/>
        <el-table-column prop="unFinishedInvoice" label="未开票金额" header-align="center" align="right" min-width="100" v-if="check('未开票金额')"/>
        <el-table-column prop="hope_time" label="期望开票时间" header-align="center" align="center" min-width="120" v-if="check('期望开票时间')">
          <template slot-scope="scope">
            {{ scope.row.applyArr ? (scope.row.applyArr.hope_time != '0000-00-00' ? scope.row.applyArr.hope_time : '暂无') : '暂无' }}
          </template> 
        </el-table-column>
        <el-table-column prop="time" label="开票时间" header-align="center" align="center" min-width="120" v-if="check('开票时间')">
          <template slot-scope="scope">
            {{ scope.row.applyArr ? (scope.row.applyArr.invoice_date != '0000-00-00' ? scope.row.applyArr.invoice_date : '暂无') : '暂无' }}
          </template>
        </el-table-column>
        <el-table-column prop="type" label="发票类型" header-align="center" align="center" min-width="120" v-if="check('发票类型')">
          <template slot-scope="scope">
            {{ scope.row.applyArr ? dd.invoice_type[scope.row.applyArr.type] : '暂无'}}
          </template> 
        </el-table-column>
        <el-table-column prop="receivedAmount" label="已收款" header-align="center" align="right" min-width="100" v-if="check('已收款')">
        </el-table-column>
        <el-table-column prop="unReceivedAmount" label="未收款" header-align="center" align="right" min-width="100" v-if="check('未收款')">
        </el-table-column>
        <el-table-column prop="is_receive" label="收款状态" header-align="center" align="center" min-width="80" v-if="check('收款状态')">
          <template slot-scope="scope">
            {{ scope.row.applyArr ? dd.is_receive_apply[scope.row.applyArr.is_receive] : '未收款'}}
          </template> 
        </el-table-column>
        <el-table-column prop="" label="操作" header-align="center" align="center" width="250" fixed="right" v-if="NodeInclude('41') || NodeInclude('42') || NodeInclude('43') || NodeInclude('44')">
          <template slot-scope="scope">
            <div class="linkwrap">
              <!-- apply_status 1是未申请，0已申请 -->
              <!-- isAllCancel 1是全部作废，0未全部作废 -->              
              <el-link type='primary' class="link" @click="handleClick(scope.row)" v-if="NodeInclude('41')" :disabled="scope.row.applyArr?.apply_status == '0'">{{scope.row.applyArr?.apply_status == '0' ? '已申请开票' : '申请开票'}}</el-link>
              <el-link type='primary' class="link" :class="{ 'grey': !scope.row.applyArr || scope.row.applyArr?.hope_time == '0000-00-00' }" @click="invoiceClick(scope.row)" v-if="NodeInclude('42')">更新发票状态</el-link>
              <el-link type='primary' class="link" @click="updateClick(scope.row)" v-if="NodeInclude('43')">更新收款状态</el-link>
              <el-link type='primary' class="link" :class="{ 'grey': !scope.row.applyArr }" v-if="NodeInclude('44')" @click="viewClick(scope.row)">查看</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="lower"  v-if="NodeInclude('102')">
        <div>计划收款金额合计：{{ total_item.totalAmount }}</div>
        <div>已开票金额合计：{{ total_item.totalInvoiceAmount }}</div>
        <div>未开票金额合计：{{ total_item.totalUnInvoiceAmount }}</div>
        <div>已收款合计：{{ total_item.totalReceiveAmount }}</div>
        <div>未收款合计：{{ total_item.totalUnReceiveAmount }}</div>
      </div> 
      <div class="apage">
        <el-pagination @current-change="handleCurrentChange" :current-page="p" :page-size="30"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
// CodeToText
import * as api from '@/api'
import {thousands} from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'custom',
  data() {
    return {
      nodeLimtList: [],
      level: '',
      checkList: [
        '合同编号',
        '客户公司名称',
        '品牌',
        '项目名称',
        '收款计划',
        '计划收款金额',
        '计划收款时间',
        '开票状态',
        '已开票金额',
        '未开票金额',
        '期望开票时间',
        '开票时间',
        '发票类型',
        '已收款',
        '未收款',
        '收款状态',
      ],
      yearList:[],
      itemList: [],
      total: 0,
      perPage: 30,
      p: 1,
      form: {
        key: '',
        atype: 'contract_name',
        hope_time: ['', ''],
      },
      total_item: {},
    }
  },
  computed: {
    tags() {
      let temp = [
        {
          key: this.dd.proType[this.form.atype],
          val: 'atype',
          value: this.form.key,
          active: !!this.form.atype && !!this.form.key,
        },
        {
          key: '期望开票时间',
          val: 'hope_time',
          value: this.dateValue(this.form.hope_time),
          active: !!this.form.hope_time && this.form.hope_time[0] && !!this.form.hope_time && this.form.hope_time[1],
        },
        {
          key: '开票状态',
          val: 'status',
          value: this.dd.invoice_status[this.form.status],
          active: !!this.form.status,
        }, 
        {
          key: '是否收款',
          val: 'is_receive',
          value: this.dd.is_receive_apply[this.form.is_receive],
          active: !!this.form.is_receive,
        }, 
        {
          key: '是否申请发票',
          val: 'is_apply',
          value: this.dd.is_bill_apply[this.form.is_apply],
          active: !!this.form.is_apply,
        }, 
        {
          key: '认列年份',
          val: 'year',
          value: this.form.year,
          active: !!this.form.year,
        }, 
      ]
      temp = temp.filter((item) => item.active)
      return temp
    },
  },
  created() {
    var date = new Date()
    var year = date.getFullYear() + 1
    this.getYearList(year);
    this.query.year && (this.form.year = this.query.year)
    this.query.is_receive && (this.form.is_receive = this.query.is_receive)
    this.query.status && (this.form.status = this.query.status)
  },  
  mounted() {
    this.getStoreFn()
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    getYearList(y) {
      for (let i = 2021; i <= y; i++) {
        this.yearList.push(i)
      }
    },
    exportInvoiceApplyToExcel() {
      window.location = api.exportBillListToExcel({
        ...this.form,
        start_time: this.fdate(this.form.hope_time[0]) || '',
        end_time: this.fdate(this.form.hope_time[1]) || '',
      })
    },
    dateValue(dateArr) {
      if (Array.isArray(dateArr)) {
        return this.fdate(dateArr[0]) + '-' + this.fdate(dateArr[1])
      } else {
        return ''
      }
    },
    link(url) {
      this.$router.push(url)
    },
    check(key) {
      return this.checkList.includes(key)
    },

    handleClick(item) {
      console.log(item)
      if (item.applyArr) {
        if (item.applyArr.apply_status == '0') {
          return false
        }
        else {
          this.$router.push({
            path: '/apply/add',
            query: { id: item.applyArr.id },
          })
        }
      }
      else {
        this.$router.push({
          path: '/apply/add',
          query: { pid: item.projectArr.id, bid: item.id,  },
        })
      }
    },

    invoiceClick(item) {
      console.log(item)   
      // this.$router.push({
      //   path: '/apply/update',
      //   query: { id: item.id },
      // })
      if (!item.applyArr || item.applyArr.hope_time == '0000-00-00') {
        this.$message.error('请先进行发票申请！')
        return false
      }
      else {
        this.$router.push({
          path: '/apply/update',
          query: { id: item.applyArr.id,  },
        })
      }
    },

    updateClick(item) {
      console.log(item)
      // this.$router.push({
      //   path: '/apply/pay',
      //   query: { id: item.id },
      // })
      if (!item.applyArr) {
        this.$router.push({
          path: '/apply/pay',
          query: { pid: item.projectArr.id, bid: item.id,  },
        })
      }
      else {
        this.$router.push({
          path: '/apply/pay',
          query: { id: item.applyArr.id,  },
        })
      }
    },

    viewClick(item) {
      if (!item.applyArr) {
        this.$message.error('请先进行发票操作后查看！')
        return false
      }
      this.$router.push({
        path: '/apply/view',
        query: { id: item.applyArr.id },
      })
    },

    search() {
      this.p = 1
      store.commit('setApplyData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },

    getStoreFn() {
      this.form = Object.keys(store.state.applyData).length != 0 ? store.state.applyData : this.form
      this.getList()
    },    

    getList() {
      this.checkUrlFn()
      this.checkNodeFn('61')
      const time = this.form.hope_time || []
      const postData = {
        ...this.form,
        p: this.p,
        per_page: this.perPage,
        hope_time_from: this.fdate(time[0]),
        hope_time_to: this.fdate(time[1]),
        [this.form.atype]: this.form.key,//搜索
      }
      api.getBillList(postData).then((res) => {
        // this.itemList = res.itemList
        this.itemList = res.itemList.map((item)=>{
          item.receivedAmount = thousands(Number(item.receivedAmount))
          item.unFinishedInvoice = thousands(Number(item.unFinishedInvoice))
          item.unReceivedAmount = thousands(Number(item.unReceivedAmount))
          item.finishedInvoice = thousands(Number(item.finishedInvoice))
          item.amount = thousands(Number(item.amount))
          return item
        })
        this.total_item = res.total_item
        this.total_item.totalAmount = thousands(Number(this.total_item.totalAmount))
        this.total_item.totalInvoiceAmount = thousands(Number(this.total_item.totalInvoiceAmount))
        this.total_item.totalReceiveAmount = thousands(Number(this.total_item.totalReceiveAmount))
        this.total_item.totalUnInvoiceAmount = thousands(Number(this.total_item.totalUnInvoiceAmount))
        this.total_item.totalUnReceiveAmount = thousands(Number(this.total_item.totalUnReceiveAmount))
        this.total = +res.totalNum
        setTimeout(() => {
          //权限
          this.level = store.state.level       
        }, 200);     
      })
    },
    removeTag(tag) {
      if (tag.val === 'hope_time') {
        this.form.hope_time = ['', '']
      }
      !{
        type: () => {
          this.form['key'] = undefined
        },
      }[tag.val]?.()
      this.form[tag.val] = ''
      this.form.key = this.form.atype == '' ? '' : this.form.key 
      store.commit('setApplyData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
      console.log(tag)
    },
    handleCurrentChange(p) {
      this.p = p
      
      store.commit('setApplyData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
.none {
  pointer-events: none;
  opacity: 0;
}

.imgwrap {
  width: 200px;
  height: 100px;
}

.tips {
  background-color: rgba(#a6aede, 0.2);
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  color: #9c9a9a;
  padding: 20px;
  font-size: 14px;

  p {
    padding-bottom: 10px;
  }
}

.flist {
  display: flex;
}

.info {
  @extend %box;
  border-bottom: 20px;
  margin-bottom: 20px;

  ul {
    @extend %center;
    flex-flow: row nowrap;
    padding: 76px 0 18px 0;

    li {
      flex: auto;
      position: relative;
      height: 90px;

      div {
        position: absolute;
        top: -50px;
        color: #9c9a9a;
        font: 16px/1 $font;

        &.lic {
          transform: translateX(50%);
          width: 100%;
          min-width: 135px;

          &::after {
            content: '';
            width: 135px;
            height: 30px;
            position: absolute;
            left: calc(50% - 67px);
            top: 28px;
            background: url(../../assets/updown.png) no-repeat transparent;
          }
        }
      }

      @extend %center;

      strong {
        font: 30px/1 $font;
        padding: 10px 0 10px 0;
      }

      span {
        color: #999;
      }

      &:not(:last-child) {
        border-right: 1px solid #ddd;
      }
    }
  }
}

.filterwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 20px 0;
  .filter {
    width: 85%;
  }
  .btnarea {
    box-sizing: border-box;
    width: 15%;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.el-checkbox-group.filtergroup .el-checkbox {
 width: auto;
}

.apage {
  background: #f2f2f2;
  padding: 8px;
  text-align: right;
}

.el-select {
  margin-right: 20px;
}

.el-tag {
  margin-right: 20px;
  height: 36px;
  line-height: 36px;
  border: none;
}

.form {
  @extend %box;
  padding: 30px;
  margin-bottom: 20px;
}

.table {
  @extend %box;
  padding: 30px;
}

.lower {
  @extend %start;
  padding: 20px 0;
  font: 600 14px/20px $font;

  >div {
    margin-right: 15px;
  }
}

.line {
  text-align: center;
}

.grey {
  color: #999;
}

.linkwrap {
  font-size: 12px;
  &.normal {
    color: #606266;
    a {
      color: #606266;
      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }
      >span {
        font-size: 12px;
        color: #606266;
      }
    }
  }
}
</style>
